<template>
    <header class="header app__header">
        <div class="app__header__logo" @click="$router.push('/')">
            <img src="../assets/img/vpackslogo.png" alt="V-Packs logo">
        </div>
    </header>
</template>

<script>
    export default {
        name: "TheHeader"
    }
</script>